import { useState, useEffect } from 'react'
import { signin } from '../../../api'
import { Navigate } from 'react-router-dom';
import axios from 'axios'
import './styles.css'
import logo from './../images/logo.svg'

function Login({isAuth, setIsAuth}){

  const [isLoading, setIsLoading] = useState(true)
  const [message, setMessage ] = useState('')
  useEffect(() => {
    const isAuthenticated = () => {
      axios.get('https://job-portal-back123.herokuapp.com/auth/admin/verify', {
        credentials: "include",
        withCredentials: true,
      }).then(res => {
        setIsAuth(res.data.success)
        setIsLoading(false)
      }).catch(err => {
        console.log(err)
        setIsLoading(false)
      })
    }
    isAuthenticated()
  }, [])

  const [formData, setFormData] = useState({
    email: "",
    password: ""
  })

  const handleChange = (event)=>{
    const { name, value } = event.target
    setFormData(prevFormData => {
        return {
            ...prevFormData,
            [name]: value
        }
    })
  }

  const handleSubmit = async (event)=>{
    event.preventDefault();
    const res = await fetch('https://job-portal-back123.herokuapp.com/auth/signin/',{
      method: "POST",
      headers: {
        "content-type": "application/json",
        accept : "application/json",
        Authorization:localStorage.getItem("token")
      },
      mode: "cors",
      credentials: "include",
      withCredentials: true,
      body: JSON.stringify({
        ...formData
      })
    })

    console.log(res)
    const data = await res.json()
    console.log("Data", data)
    if (data.success) {
      console.log("Data to be set:", data.token)
      window.localStorage.setItem("token", data.token)
      window.location = "/admin"
    } else {
      setMessage(data.message)
    }

  }

  return(
    <>
      {(isAuth && !isLoading) && <Navigate to="/admin"/>}
      <div className="admin__login">
        <div>
          <div className="header__logo">
            <img src={logo} alt="AB hires"/>
            <h1>AB hires</h1>
          </div>
          <form  className="admin__login__form" onSubmit={handleSubmit}>
            <h1>Admin Login</h1>
            <input className="form__input" onChange={handleChange} placeholder="email" name="email" value={formData.email} type="email" required/>
            <input className="form__input" onChange={handleChange} placeholder="password" name="password" value={formData.password} type="password" required/>
            <button className="btn btn--submit" type="submit">Login</button>
            {(message) && <p className="message__error">{message}</p>}
          </form>
        </div>
      </div>
    </>
  )
}

export default Login
